import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    OpenApiDisableCRMIntegrationMethod,
    type OpenApiDisableCRMIntegrationSearchParams,
    OpenApiDisableCRMIntegrationUrl,
    OpenApiGetCRMAuthMethod,
    type OpenApiGetCRMAuthResponseSuccess,
    type OpenApiGetCRMAuthSearchParams,
    OpenApiGetCRMAuthUrl,
} from '#shared/api/schema';

type CRMAuthSearchParams = Omit<OpenApiGetCRMAuthSearchParams, 'crmType'> & {
    // TODO SS-17978 Удалить расширение после обновления OpenAPI-схемы
    crmType: OpenApiGetCRMAuthSearchParams['crmType'] | 'mindbox';
};

type CRMDisableSearchParams = Omit<OpenApiDisableCRMIntegrationSearchParams, 'crmType'> & {
    // TODO SS-17978 Удалить расширение после обновления OpenAPI-схемы
    crmType: OpenApiDisableCRMIntegrationSearchParams['crmType'] | 'mindbox';
};

const api = createApi({
    name: 'entities/integration/api/integrationCrmApi',
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            getCRMAuth: builder.query<OpenApiGetCRMAuthResponseSuccess, CRMAuthSearchParams>({
                query: (params) => {
                    return {
                        url: OpenApiGetCRMAuthUrl,
                        method: OpenApiGetCRMAuthMethod,
                        params: {
                            crmType: params.crmType,
                        },
                    };
                },
            }),
            disableCRM: builder.mutation<void, CRMDisableSearchParams>({
                query: (params) => {
                    return {
                        url: OpenApiDisableCRMIntegrationUrl,
                        method: OpenApiDisableCRMIntegrationMethod,
                        params,
                    };
                },
            }),
        };
    },
});

export const useGetIntegrationCRMAuth = api.useGetCRMAuthQuery;
export const useLazyGetIntegrationCRMAuth = api.useLazyGetCRMAuthQuery;
export const disableIntegrationCRM = api.endpoints.disableCRM.mutate;
